import React from "react";
import {
    useNavigation,
    useSubmit,
    useActionData,
    useLocation,
} from "react-router";
import { Card, Button, Form, FloatingLabel } from "react-bootstrap";
import BackLink from "./BackLink";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import { EmailLoginSchema } from "schema/account";
import { renderLoadingProgressToast } from "components/shared/Toasts";
import axios from "axios";

export async function action({ request }) {
    const data = await request.json();
    // Prepare HTTP Basic Auth header
    const basicAuth = btoa(`${data.email}:${data.password}`);
    var result = await renderLoadingProgressToast(
        axios.post(
            "account/login",
            {}, // No body needed for basic auth
            {
                headers: {
                    Authorization: `Basic ${basicAuth}`,
                },
            }
        )
    )
        .then(() => ({ success: true }))
        .catch((error) => {
            if (error.response?.data) {
                var data = error.response?.data;
                return Promise.resolve({
                    success: false,
                    reason: data["description"],
                });
            }
            return Promise.reject(error);
        });
    if (result.success === true) {
        // Get the return URL from the request data, default to home page
        const returnUrl = data.returnUrl || "/";
        window.location.replace(returnUrl);
        return null;
    }
    return result;
}

const EmailSignIn = () => {
    const submit = useSubmit();
    const actionData = useActionData();
    const navigation = useNavigation();
    const location = useLocation();
    const isNavigating =
        navigation.state === "submitting" || navigation.state === "loading";

    const onSignIn = async (data) => {
        // Include the return URL from location state if available
        const returnUrl = location.state?.returnUrl;
        await submit(
            { ...data, returnUrl },
            {
                action: "/account/signin/email",
                method: "post",
                encType: "application/json",
            }
        );
    };

    const onError = (errors, e) => console.error(errors, e);

    const {
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(EmailLoginSchema),
        defaultValues: {
            email: "",
            password: "",
        },
    });

    return (
        <div style={{ width: "100%", maxWidth: "350px", margin: "0 auto" }}>
            <BackLink />
            <Card className="mt-3" style={{ width: "100%" }} border="secondary">
                <Card.Header>Email Login</Card.Header>
                <Card.Body>
                    <Form
                        onSubmit={handleSubmit(onSignIn, onError)}
                        onReset={reset}
                    >
                        <Form.Group className="mb-3">
                            <Controller
                                control={control}
                                name="email"
                                render={({
                                    field: { onChange, value, ref },
                                }) => (
                                    <FloatingLabel
                                        controlId="email"
                                        label="Email"
                                    >
                                        <Form.Control
                                            type="email"
                                            rules={{ required: true }}
                                            isInvalid={errors.email}
                                            onChange={onChange}
                                            value={value}
                                            data-testid="input_email"
                                            ref={ref}
                                            placeholder="Email"
                                            name="email"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.email?.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                )}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Controller
                                control={control}
                                name="password"
                                render={({
                                    field: { onChange, value, ref },
                                }) => (
                                    <FloatingLabel
                                        controlId="password"
                                        label="Password"
                                    >
                                        <Form.Control
                                            type="password"
                                            rules={{ required: true }}
                                            isInvalid={errors.password}
                                            onChange={onChange}
                                            value={value}
                                            data-testid="input_password"
                                            ref={ref}
                                            placeholder="Password"
                                            name="password"
                                        />
                                        <Form.Control.Feedback type="invalid">
                                            {errors.password?.message}
                                        </Form.Control.Feedback>
                                    </FloatingLabel>
                                )}
                            />
                        </Form.Group>
                        {actionData?.reason && (
                            <div className="text-danger mb-3">
                                {actionData.reason}
                            </div>
                        )}
                        <div className="d-grid gap-2">
                            <Button
                                type="submit"
                                variant="primary"
                                disabled={isNavigating}
                            >
                                Sign In
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};

export default EmailSignIn;
